module.exports = __webpack_public_path__ + "img/header-logo.a6ec1db8.png";